import angular from 'angular';
import { CapabilityIdEnum } from 'src/app/shared/capabilities-and-permissions';

SatisfactionSurveysController.$inject = ['sites', '$scope', 'ParametersFactory', '$state', '$stateParams', 'satisfactionSurveys',
  'SiteFilterHelperFactory', 'AlertingFactory', '$mdDialog', 'loggedUser', 'TopToolbarFactory', 'StrategiesFactory', 'QuickRepliesFactory'];
export function SatisfactionSurveysController(sites, $scope, ParametersFactory, $state, $stateParams, satisfactionSurveys,
  SiteFilterHelperFactory, AlertingFactory, $mdDialog, loggedUser, TopToolbarFactory, StrategiesFactory, QuickRepliesFactory) {

  init();
  $scope.addSatisfactionSurvey = addSatisfactionSurvey;
  $scope.copySatisfactionSurvey = copySatisfactionSurvey;
  $scope.isMarketing = $state.current.data.isMarketingMode;

  function addSatisfactionSurvey() {
    $mdDialog.show({
      controller: 'AddSatisfactionSurveyController',
      template: require('./satisfaction-survey.add.html'),
      clickOutsideToClose: true,
      locals: {
        'sites': $scope.sites,
        'survey': {
          'name': '',
          'is_active': 0,
          'site_id': $scope.filteredSiteId,
          'isMarketing': $scope.isMarketing
        }
      }
    }).then(newSurvey => {
      ParametersFactory.addSatisfactionSurvey($stateParams.companyId, newSurvey.site_id, newSurvey)
        .then(response => {
          SiteFilterHelperFactory.addNameIconAndSortKeyToItems([response.data], $scope.sites);
          $scope.mySatisfactionSurveys.push(response.data);
          AlertingFactory.success('parameters/satisfaction_surveys/add_satisfaction_survey/ok');

          QuickRepliesFactory.buildUserEmailsAndDates($scope.mySatisfactionSurveys, true);
        },
          () => AlertingFactory.error('parameters/satisfaction_surveys/add_satisfaction_survey/ko')
        );
    });
  }

  function copySatisfactionSurvey(survey) {
    const result = {};
    $scope.mySatisfactionSurveys.forEach(survey => {
      if (!result[survey.site_id]) {
        result[survey.site_id] = [];
      }
      result[survey.site_id].push(survey.name);
    });
    $mdDialog.show({
      controller: ['$scope', function ($scope) {
        $scope.survey = survey;
        $scope.surveyNamesBySiteId = result;
        $scope.cancelDialog = $mdDialog.cancel;
        $scope.hideDialog = $mdDialog.hide;
      }],
      template: `
      <angular-satisfaction-survey-duplicate
        [survey]="survey"
        [survey-names-by-site-id]="surveyNamesBySiteId"
        (hide-dialog)="hideDialog($event)"
        (cancel-dialog)="cancelDialog()">
      </angular-satisfaction-survey-duplicate>`,
      clickOutsideToClose: true
    }).then(data => {
      // First copy the scenario from the old survey
      QuickRepliesFactory.copyScenario($stateParams.companyId, survey.site_id, data.selectedSiteId, survey.scenario.common.id, data.surveyName, 'satisfaction-survey')
        .then(res => {

          // Then create a new survey with the copied scenario
          ParametersFactory.addSatisfactionSurvey($stateParams.companyId, data.selectedSiteId, {
            name: data.surveyName,
            is_active: 0,
            site_id: data.selectedSiteId,
            scenario_id: res.data.new_scenario_id,
            isMarketing: $scope.isMarketing
          })
            .then(response => {

              // We don't want to copy these properties over from the old survey
              const skippedProperties = ['id', 'name', 'site_id', 'scenario'];

              for (let prop in survey) {
                if (!skippedProperties.includes(prop)) {
                  response.data[prop] = survey[prop];
                }
              }

              // Update the new survey on the server and reload
              ParametersFactory.updateSatisfactionSurvey($stateParams.companyId, response.data.site_id, response.data.id, response.data)
                .then(() => {
                  AlertingFactory.success('parameters/satisfaction_surveys/copy_satisfaction_survey/success');
                  $state.reload();
                },
                  () => AlertingFactory.error('parameters/satisfaction_surveys/update_satisfaction_survey/ko'));

            },
              ({ data }) => {
                if (data?.error?.reason === 'marketing-survey-already-exists-for-same-account') {
                  AlertingFactory.error('parameters/satisfaction_surveys/update_satisfaction_survey/already-exists');
                } else {
                  AlertingFactory.error('parameters/satisfaction_surveys/update_satisfaction_survey/ko');
                }
              });

        },
          AlertingFactory.httpErrorHandler());
    });
  }

  function init() {
    TopToolbarFactory.setButton('parameters/satisfaction_surveys/new_satisfaction_survey', addSatisfactionSurvey, $scope, 'add-survey');
    $scope.$watch('mySatisfactionSurveys.length == maxSatisfactionSurveyNumber',
      newValue => TopToolbarFactory.updateButtonDisable(newValue, $scope));

    const localStorageKey = `satisfaction-surveys-filtered-site-id-for-company-${$stateParams.companyId}`;
    const higherPriorityinitialValue = null;
    const hasAllSitesItem = true;
    const filteredSites = SiteFilterHelperFactory
      .filterSitesThatHaveCapability(sites, loggedUser, CapabilityIdEnum.Automation)
      .filter(site => StrategiesFactory.getStrategy(site.type_name).canHaveSurveys());
    SiteFilterHelperFactory.initScope($scope, filteredSites, localStorageKey, higherPriorityinitialValue, hasAllSitesItem);
    $scope.lang = (!angular.isUndefined(loggedUser.lang)) ? loggedUser.lang : 'en';
    $scope.sortColumn = 'sortKey'; // sort by site name + site type by default
    $scope.$watch('mySatisfactionSurveys', newSurveys => {
      SiteFilterHelperFactory.addNameIconAndSortKeyToItems(newSurveys, $scope.sites); // pass $scope.sites as it has sortKeys (sites from the Controller function doesn't)
    });

    $scope.mySatisfactionSurveys = satisfactionSurveys;
    $scope.scenarioStateLocalStorageKey = `satisfaction-surveys-scenario-state-for-company-${$stateParams.companyId}`;
    $scope.filteredScenarioState = SiteFilterHelperFactory.LocalStorageFactory.getItem($scope.scenarioStateLocalStorageKey) || -1;

    QuickRepliesFactory.buildUserEmailsAndDates($scope.mySatisfactionSurveys, true);
  }

  $scope.$watch('filteredScenarioState', (newValue) => {
    SiteFilterHelperFactory.LocalStorageFactory.setItem($scope.scenarioStateLocalStorageKey, newValue);
  }, true);

}
